<template>
    <div class="launch" :class="{active: isActive}">
        <div class="content">
            即刻出發<br/>為了你的願望
        </div>
        <img class="logo" src="@/assets/img/logo-banner.svg">
    </div>
</template>

<script>
    export default {
        name: 'Launch',
        data() {
           return {
               isActive: false,
           }
        },
        mounted() {
            this.isActive = true;
        }
    };
</script>

<style scoped>
    .launch {
        background-color: rgba(51,153,51,1);
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .content {
        margin-top: 200px;
        color: #FFFFFF;
        font-size: 27px;
        font-weight: 500;
        letter-spacing: 4.63px;
        line-height: 38px;
        text-align: center;
    }

    .logo {
        margin-top: 20px;
    }

</style>
